import { makeRequest } from '@/base/MaRequestPooler.js'

export function add({ trackId, groupName }) {
  return makeRequest(`/user-keyword-group/app/${trackId}?groupName=${encodeURIComponent(groupName)}`, {
    method: 'POST',
  })
}

export function remove({ userKeywordGroupId }) {
  return makeRequest(`/user-keyword-group/${userKeywordGroupId}`, {
    method: 'DELETE',
  })
}
